// extracted by mini-css-extract-plugin
export default {"EditorDropzone":"EditorDropzone__A_S4Hzx4yxM_"};